import { render, staticRenderFns } from "./EventGatingModal.vue?vue&type=template&id=b7e74cc4&scoped=true&"
import script from "./EventGatingModal.vue?vue&type=script&lang=ts&"
export * from "./EventGatingModal.vue?vue&type=script&lang=ts&"
import style0 from "./EventGatingModal.vue?vue&type=style&index=0&id=b7e74cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e74cc4",
  null
  
)

export default component.exports